export default __webpack_public_path__ + "static/media/html.b29f4382.png";